import "../styles/PlayerCards.css"
import { jwtDecode } from "jwt-decode";
import PlayerOptionsItem from "./items/PlayerOptionsItem";
function PlayerOptions({ size, options }) {
    const localDetails = jwtDecode(localStorage.getItem("token"));
    return (
        <div className={`player-cards-container-${size}`}>
            <div style={{ display: "flex" }}>
                <img src={localDetails.picture} alt="" style={{ width: `${size === "lg" ? "3vw" : "40px"}`, height: `${size === "lg" ? "3vw" : "40px"}`, borderRadius: `${size === "lg" ? "1.5vw" : "20px"}`, marginRight: "10px" }} />
                <div className={`player-cards-header`}>
                    Your Options
                </div>
            </div>
            <div>
                {options.map((option) => {
                    return <PlayerOptionsItem key={option.id} option={option} size={size}/>
                })}
            </div>
        </div>
    )
}

export default PlayerOptions;